// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.large-table-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto auto 10px auto;
}
.large-table-row .row-select {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  cursor: default;
}
.large-table-row .row-select input[type=checkbox] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.large-table-row .row-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  font-size: x-large;
  font-weight: bold;
  overflow-x: hidden;
  white-space: nowrap;
}
.large-table-row .row-body {
  padding: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 8px;
  justify-content: center;
  align-content: space-between;
  width: 70%;
  height: 100%;
  flex-basis: auto;
}
.large-table-row .row-body .row-field {
  display: flex;
  padding: 0 8px 0 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}
.large-table-row .row-body .row-field label {
  text-decoration: underline;
}
.large-table-row .row-body .row-field label:hover {
  cursor: pointer;
}
.large-table-row .row-body .row-field .field-value {
  font-weight: bold;
}

.tcs-container-corners {
  /* Smooth the scaling effect. */
  background-color: rgba(141, 198, 63, 0.2);
  text-shadow: 0 0 3px white;
  transition: transform 0.3s ease-in-out;
}
.tcs-container-corners:hover {
  cursor: pointer;
  background: #ffffff;
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
}
.tcs-container-corners .row-label {
  background-color: #8dc63f !important;
}
.tcs-container-corners .row-label label:hover {
  cursor: pointer;
}

.tcs-container-corners-dark {
  /* Smooth the scaling effect. */
  background-color: rgba(29, 15, 64, 0.2);
  text-shadow: 0 0 3px white;
  transition: transform 0.3s ease-in-out;
}
.tcs-container-corners-dark:hover {
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0 0 10px 4px rgb(29, 15, 64);
  transform: scale(1.1);
  /* Specify the animation for this element. */
  animation: zoomIn 2s infinite;
}
.tcs-container-corners-dark .row-label {
  color: white;
  background-color: #1d0f40 !important;
}

@media screen and (max-width: 1280px) {
  .row-label {
    width: 40% !important;
  }
}
@media screen and (max-width: 1000px) {
  .row-label {
    width: 100% !important;
  }
  .row-body {
    display: none !important;
  }
}
@keyframes scrollText {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/large-table-row/large-table-row.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2BAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACN;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;AAFN;AAIM;EACE,0BAAA;AAFR;AAIM;EACE,eAAA;AAFR;AAKM;EACE,iBAAA;AAHR;;AASA;EACE,+BAAA;EACA,yCAAA;EACA,0BAAA;EACA,sCAAA;AANF;AAOE;EACE,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,4CAAA;EACA,6BAAA;AALJ;AAOE;EACE,oCAAA;AALJ;AAMI;EACE,eAAA;AAJN;;AASA;EACE,+BAAA;EACA,uCAAA;EACA,0BAAA;EACA,sCAAA;AANF;AAOE;EACE,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,4CAAA;EACA,6BAAA;AALJ;AAOE;EACE,YAAA;EACA,oCAAA;AALJ;;AASA;EACE;IACE,qBAAA;EANF;AACF;AASA;EACE;IACE,sBAAA;EAPF;EASA;IACE,wBAAA;EAPF;AACF;AAUA;EACE;IACE,wBAAA;EARF;EAUA;IACE,4BAAA;EARF;AACF","sourcesContent":[".large-table-row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: auto auto 10px auto;\n\n  .row-select {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 8px;\n    cursor: default;\n\n    input[type=\"checkbox\"] {\n      width: 18px;\n      height: 18px;\n      cursor: pointer;\n    }\n  }\n\n  .row-label {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 30%;\n    font-size: x-large;\n    font-weight: bold;\n    overflow-x: hidden;\n    white-space: nowrap;\n  }\n\n  .row-body {\n    padding: 4px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    column-gap: 12px;\n    row-gap: 8px;\n    justify-content: center;\n    align-content: space-between;\n    width: 70%;\n    height: 100%;\n    flex-basis: auto;\n\n    .row-field {\n      display: flex;\n      padding: 0 8px 0 8px;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: center;\n      height: 100%;\n      border-radius: 10px;\n      box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n\n      label {\n        text-decoration: underline;\n      }\n      label:hover {\n        cursor: pointer;\n      }\n\n      .field-value {\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n.tcs-container-corners {\n  /* Smooth the scaling effect. */\n  background-color: rgba(141, 198, 63, 0.2);\n  text-shadow: 0 0 3px white;\n  transition: transform 0.3s ease-in-out;\n  &:hover {\n    cursor: pointer;\n    background: #ffffff;\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n  }\n  .row-label {\n    background-color: #8dc63f !important;\n    label:hover {\n      cursor: pointer;\n    }\n  }\n}\n\n.tcs-container-corners-dark {\n  /* Smooth the scaling effect. */\n  background-color: rgba(29, 15, 64, 0.2);\n  text-shadow: 0 0 3px white;\n  transition: transform 0.3s ease-in-out;\n  &:hover {\n    cursor: pointer;\n    background: #ffffff;\n    box-shadow: 0 0 10px 4px rgb(29, 15, 64);\n    transform: scale(1.1);\n    /* Specify the animation for this element. */\n    animation: zoomIn 2s infinite;\n  }\n  .row-label {\n    color: white;\n    background-color: #1d0f40 !important;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .row-label {\n    width: 40% !important;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .row-label {\n    width: 100% !important;\n  }\n  .row-body {\n    display: none !important;\n  }\n}\n\n@keyframes scrollText {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
